<template>
    <div>
        <div class="bg-brand-neutral-2 rounded-xl space-x-3 flex px-4 py-3.5">
            <span
                class="fi fi-br-search text-brand-neutral-4-50 text-2xl flex"
            ></span>
            <input
                class="bg-transparent placeholder:text-brand-neutral-4-50 text-brand-neutral-6 w-full"
                placeholder="Pesquisar"
                :value="applicationSearchValue"
                @input="onSearch"
            />
        </div>
        <div class="mt-2" ref="applicationsContainerRef">
            <NuxtLink
                class="flex items-center border-b-2 border-brand-neutral-3 py-4 gap-2"
                v-for="application of applications?.results"
                :key="application._id"
                :to="`/applications/${application._id}`"
            >
                <NuxtImg
                    class="rounded-full object-cover h-16 w-16 shrink-0"
                    :src="application.image"
                    :alt="application.name"
                />
                <div class="flex flex-col gap-2">
                    <h4 class="text-brand-neutral-6-95 font-medium text-sm">
                        {{ application.name }}
                    </h4>
                    <p
                        v-if="application.userApplication"
                        class="text-brand-neutral-7 font-bold"
                    >
                        {{
                            $utils.formatPoints(
                                application.userApplication.balance
                            )
                        }}
                        Pontos
                    </p>
                </div>
            </NuxtLink>
        </div>
    </div>
</template>
<script setup lang="ts">
import debounce from "debounce";

const applicationsRes = await useApi("/applications");

const applicationSearchValue = ref("");
const applications = ref<IPaginationResults<IApplication>>(applicationsRes);
const applicationsContainerRef = ref<HTMLDivElement | null>(null);

const alertsStore = useAlertsStore();
const { $api } = useNuxtApp();

const getBaseApplicationsUrl = () => {
    return `/applications?limit=6${
        applicationSearchValue.value.length >= 3
            ? `&name=${applicationSearchValue.value}`
            : ""
    }`;
};

const onSearch = (event: Event) => {
    debounce(
        () => getApplications((event.target as HTMLInputElement).value),
        100
    )();
};

const getApplications = async (search: string) => {
    try {
        if (search === applicationSearchValue.value) {
            return;
        }

        applicationSearchValue.value = search;

        const res = await $api(getBaseApplicationsUrl());

        applications.value = res;
    } catch (error) {
        /**
         * @todo Log error to sentry
         */
        console.error(error);

        alertsStore.addAlert({
            title: "Falha ao buscar estabelecimentos",
            variant: "danger",
        });
    }
};

onMounted(() => {
    const observer = new IntersectionObserver(
        async (entries) => {
            if (entries[0].isIntersecting && applications.value.hasNext) {
                const res = await $api(
                    `${getBaseApplicationsUrl()}${
                        applications.value.hasNext
                            ? `&next=${applications.value.next}`
                            : ""
                    }`
                );

                applications.value = {
                    ...res,
                    results: [...applications.value.results, ...res.results],
                };
            }
        },
        {
            root: applicationsContainerRef.value,
            rootMargin: "0px",
            threshold: 1.0,
        }
    );

    if (applicationsContainerRef.value?.lastElementChild) {
        observer.observe(
            applicationsContainerRef.value?.lastElementChild as HTMLElement
        );
    }
});
</script>
